import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import vuetify from './plugins/vuetify';
// See available icons here: https://material.io/resources/icons/?style=baseline
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import i18n from './i18n'
import router from './router'
import store from './store';
import HighchartsVue from "highcharts-vue";
import axios from "axios";

Vue.config.productionTip = false
Vue.use(HighchartsVue)

new Vue({
  vuetify,
  i18n,
  router,
  store,
  created: function() {
      var self = this;

      // Initialize vuex
      this.$store.commit('common/initializeCommonStore');

      // Make the activity selection change if the selected area changes
      this.$store.watch((state) => state.common.selectedArea, () => {
          this.$store.dispatch('common/getActivitiesForCurrentArea')
      })

      axios
          .get(this.$store.getters["common/serverURL"] + '/is_logged_in/')
          .then(response => {
              if (response.status == 200 && response.data.logged_in) {
                  self.$store.commit('auth/setLoggedIn', true);

                  self.$store.commit('auth/setUserIsSuperUser', response.data.user_is_super_user);
              }
              else {
                  self.$store.commit('auth/setLoggedIn', false);
                  if (router.currentRoute.name !== 'Login') {
                      router.replace({name: 'Login'});
                  }
              }
              self.$store.commit('auth/setLoadingApp', false)
          });
  },
  render: h => h(App)
}).$mount('#app')
